import React from 'react'

import {
    ContentContainer,
    MainContainer,
    Title,
    TitleContainer,
} from './FormSubsection.styled'

interface Props {
    title: string
    rightContent?: React.ReactNode
    children?: React.ReactNode
}

function FormSubsection({ title, rightContent, children }: Readonly<Props>) {
    return (
        <MainContainer>
            <TitleContainer>
                <Title>{title}</Title>
                {rightContent && <div>{rightContent}</div>}
            </TitleContainer>
            {children && (
                <ContentContainer data-testid="content-container">
                    {children}
                </ContentContainer>
            )}
        </MainContainer>
    )
}

export default FormSubsection
